const tratamientos = [
  {
    tratamiento: "Masajes",
    tipos: [
      {
        tipo: "Relajantes",
        zonas: ["Piernas", "Brazos", "Espalda", "Cuerpo entero"],
        videoURL: "https://www.youtube.com/shorts/zjhH_Zs2Lzs",
      },
      {
        tipo: "Descontracturantes",
        zonas: ["Piernas", "Brazos", "Espalda", "Cuerpo entero"],
      },
      {
        tipo: "Deportivos",
        zonas: ["Piernas", "Brazos", "Espalda", "Cuerpo entero"],
      },
      {
        tipo: "Piedras calientes",
        zonas: ["Cuerpo entero"],
        //observaciones: "Sólo en gabinete"
      },
    ],
  },
  {
    tratamiento: "Depilación",
    tipos: [
      {
        tipo: "Tradicional con cera",
        zonas: [
          "Axilas",
          "Pecho",
          "Abdomen completo",
          "Tiro abdomen",
          "Espalda",
          "Glúteos",
          "Piernas completas",
          "Media pierna",
          "Partes íntimas",
          "Brazos completos",
        ],
        observaciones: "Sólo masculina",
        //observaciones: "Sólo en gabinete"
      },
      {
        tipo: "Roll-On",
        zonas: [
          "Pecho",
          "Abdomen completo",
          "Tiro abdomen",
          "Espalda",
          "Glúteos",
          "Piernas completas",
          "Media pierna",
          "Brazos completos",
        ],
      },
      {
        tipo: "Láser definitiva femenina",
        zonas: [
          "Axilas",
          "Bozo",
          "Mentón",
          "Glúteos",
          "Pierna completa",
          "Media pierna",
          "Brazo completo",
          "Medio brazo",
          "Línea alba",
          "Espalda baja",
        ],
      },
      {
        tipo: "Láser definitiva masculina",
        zonas: [
          "Axilas",
          "Glúteos",
          "Abdomen",
          "Pecho",
          "Espalda",
          "Mentón",
          "Hombros",
          "Pierna completa",
          "Media pierna",
          "Brazo completo",
          "Medio brazo",
        ],
      },
    ],
  },
];

export default tratamientos;
